var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8105 15.1895L13.2098 11.5887C13.8653 10.5485 14.25 9.32075 14.25 8C14.25 4.27175 11.2283 1.25 7.5 1.25C3.77175 1.25 0.75 4.2725 0.75 8C0.75 11.7283 3.77175 14.75 7.5 14.75C8.82075 14.75 10.0485 14.3653 11.0887 13.7098L14.6895 17.3105C14.982 17.6037 15.366 17.75 15.75 17.75C16.134 17.75 16.518 17.6037 16.8105 17.3105C17.3962 16.7247 17.3962 15.7753 16.8105 15.1895V15.1895ZM7.5 11.75C5.43225 11.75 3.75 10.0677 3.75 8C3.75 5.93225 5.43225 4.25 7.5 4.25C9.56775 4.25 11.25 5.93225 11.25 8C11.25 10.0677 9.56775 11.75 7.5 11.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchGrey);
export default __webpack_public_path__ + "static/media/icon_search_grey.22c91aaa675d351e238ced4d247e5dad.svg";
export { ForwardRef as ReactComponent };